/**
 * One `<dialog>` (the privacy/info panel) is opened from two places — the contact form's "About
 * your information" link and the footer's "Your information" button — so a tiny id-based helper
 * is simpler than threading a ref or a context through both.
 */
export function openDialog(id: string): void {
  const el = document.getElementById(id);
  if (el instanceof HTMLDialogElement) el.showModal();
}

export function closeDialog(id: string): void {
  const el = document.getElementById(id);
  if (el instanceof HTMLDialogElement) el.close();
}
